import { AuthService } from "@adfenix/types";
import { ScopeTypes } from "types/JWT";
import useUserInfo from "./useUserInfo";

interface Props {
  /**
   * The scope where to check for allowed actions. For example "Program"
   * This was previously an enum in the back-end but it is now a string so we use a custom type for it
   * to keep track of the scopes in the front-end.
   */
  scope: ScopeTypes;

  /**
   * The action the user should be allowed to perform within the scope.
   */
  action: AuthService.ActionType;
}

export const useCheckPermission = ({ scope, action }: Props) => {
  const { permissions } = useUserInfo();

  if (!permissions) {
    return false;
  }

  return permissions[scope]?.some(ac => ac === action) ?? false;
};
